import gql from 'graphql-tag'

export const GET_ALL_PRODUCTS = gql`
query {
  Products(where: {isDeleted: {_eq: false}}){
    id
    name
    sku
    displayPrice
    isActive
    ProductCategory{
      id
      name
    }
    WarehouseStock{
      id
      totalQty
      reservedQty
      warehouseId
    }
  }
}`
export const GET_PRODUCTS_WITH_MULTI_BRANCHES = gql`
query products_with_multi_branches($statement: String = "", $aggregate: String = "") {
  ProductsWithMultiBranch: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}) {
    id
    name
    sku
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    aggregate
  }
}
`
export const GET_NO_SOLD_PRODUCTS = gql`
query no_sold_products($statement: String = "", $aggregate: String = "", $warehouseId:uuid!, $offset:Int!, $limit: Int!) {
  products: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}, offset: $offset, limit: $limit) {
    id
    name
    sku
    displayPrice
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    WarehouseStock(where: {warehouseId: {_eq: $warehouseId}}) {
      id
      totalQty 
    }
  }
}
`
export const SEARCH_PRODUCT = gql`
query searchProduct($search: String){
  products: Products(where: {name: {_ilike: $search}}) {
    id
    name
    Attachments(where: {type: {_eq:"IMAGE"}, isDefault: {_eq:true}}) {id path}
  }
}`
export const GET_ALL_PRODUCTS_IN_ADD_STOCK = gql`
query {
  Products(where: {isDeleted: {_eq: false}}){
    id
    name
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    WarehouseStock{ id totalQty warehouseId }
  }
}`

export const GET_ALL_PRODUCTS_BY_WAREHOUSE = gql`
query ($warehouseId:uuid!){
  Products: Products(where: {isDeleted: {_eq: false}}, order_by:{name:asc}){
    id
    name
    sku
    hsn
    gst
    displayPrice
    WarehouseStock(where: {warehouseId: {_eq: $warehouseId}}) {
      id
      totalQty 
    }
  }
}`
export const GET_PRODUCT_COUNT = gql`
query ($productCategoryIds:[uuid!], $filter: String){
  ProductCount: Products_aggregate(where: {productCategoryId:{_in: $productCategoryIds}, _or:[{name: {_ilike: $filter}},{sku: {_ilike: $filter}}]}){
    aggregate{
      count
    }
  }
}`
export const GET_PRODUCT_BY_ID = gql`
query ($id: uuid!){
  Products: Products(where: {id: {_eq: $id}}){
    id
    productCategoryId
    name
    nameInGuj
    sku
    hsn
    gst
    description
    lowStockThreshold
    cartonQty
    purchasePrice
    margin
    displayPrice
    mrp
    productCode
    weight
    weightUnit
    dimWidth
    dimDepth
    dimHeight
    isActive
    tags
    createdBy
    updatedBy
    youtubeURL
    tiktokURL
    isIndianProduct
    visibleOutsideSurat
    minQtyOutsideSurat
    ProductCategory{
      id
      name
    }
    WarehouseStock{
      id
      warehouseId
      productId
      totalQty
      reservedQty
      Warehouse{
        id
        name
      }
    }
    Attachments{
      id
      type
      path
      isDefault
    }
  }
}`
export const GET_PRODUCT_BY_ID_FOR_CART = gql`
query getProductByIdForCart($id: uuid!){
  product: Products(where: {id: {_eq: $id}}){
    id
    name
    sku
    pricePerUnit:displayPrice
    purchasePricePerUnit: purchasePrice 
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
  }
}`
export const GET_PRODUCT_BY_ID_FOR_PURCHASE = gql`
query getProductByIdForPurchase($id: uuid!){
  product: Products(where: {id: {_eq: $id}}){
    id
    name
    sku
    purchasePrice
    margin
    displayPrice         
  }
}`
export const CHECK_PRODUCT_SKU = gql`
query checkProductSku($sku: String!){
  Products(where: {sku:{_eq: $sku}}){
    id
  }
}`
export const GET_ALL_PRODUCT_IDS = gql`
query {
  Products{
    id
  }
}`
export const GET_PROFIT_LOSS_PRODUCTS = gql`
query profit_loss_products($statement: String = "", $aggregate: String = "") {
  products: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}) {
    id
    name
    sku    
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    aggregate    
  }
}
`